import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from 'src/environments/environment';

import { mockSearchResult } from 'src/app/core/mock/mock.search';

import { SearchCriteria, SearchResult } from './search.model';
import { SentHistoryResult } from './sent-history/sent-history.model';

import { SortEvent } from '../shared/directive/sortable.directive';
import { mockSentHistory } from '../core/mock/mock.sent-history';

@Injectable({
  providedIn: 'root'
})
export class SearchService {
  constructor(private http: HttpClient) {}

  getSentHistory(ePolicyId: number): Observable<SentHistoryResult> {
    if (environment.mock) {
      return of(mockSentHistory);
    }

    const url = `${environment.endpoint.epolicyAPI}/${ePolicyId}/history`;

    return this.http.get<SentHistoryResult>(url);
  }

  searchPolicy(
    searchCriteria: SearchCriteria,
    pageNumber: number,
    pageSize: number,
    sortable?: SortEvent
  ): Observable<SearchResult> {
    if (environment.mock) {
      return of(mockSearchResult);
    }

    let url = `${environment.endpoint.epolicyAPI}/search?page=${pageNumber}&size=${pageSize}`;
    if (sortable && sortable.direction) {
      url = url + `&sort=${sortable.column},${sortable.direction}`;
    }

    return this.http
      .post<SearchResult>(url, searchCriteria)
      .pipe(catchError((error: Error) => throwError(() => error)));
  }

  downloadContract(ePolicyId: string): Observable<BlobPart> {
    const url = `${environment.endpoint.epolicyAPI}/${ePolicyId}/documents/contract`;
    const options: any = {
      responseType: 'blob' as 'text'
    };

    return this.http.get(url, options).pipe(catchError((error: Error) => throwError(() => error)));
  }
}
